(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.glow'
  var templateUrl = require('./glow.tpl.html')

  require('angular')
    .module(MODULE_NAME, [
      require('@uirouter/angularjs').default,
      require('ng-meta').name,
      require('../sdk'),
      require('../sdk-config'),
      require('./glow'),
      require('./glow-routes')
    ])
    .config(glowIndexConfig)
    .run(glowIndexRun)

  glowIndexConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$compileProvider']
  function glowIndexConfig ($stateProvider, $urlRouterProvider, $locationProvider, $compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|tel|sms):/)
    $urlRouterProvider.otherwise('/')
    $locationProvider.html5Mode(true)

    $stateProvider
      .state('glow', {
        views: {
          'thismoment-app@': {
            templateUrl: templateUrl
          }
        },
        abstract: true
      })
  }

  glowIndexRun.$inject = ['ngMeta', 'GlowConfig']
  function glowIndexRun (ngMeta, GlowConfig) {
    ngMeta.init()
    ngMeta.setDefaultTag('title', GlowConfig.get('name'))
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/index.js